import React, { useEffect, useState, useRef } from "react";
import { SortByHeader } from "pages/Fleet/Cars/SortByHeader";
import { SearchHeader } from "pages/Fleet/Cars/SearchHeader";
import { ListView } from "pages/Fleet/Cars/ListView";
import { Container } from "pages/Fleet/Cars/CarStyled";
import { FleetFindCar } from "pages/Fleet/Cars/CarStyled";
import { useHookstate } from "@hookstate/core";
import { MESSAGE_FLEET_GLOBAL_STATES, SITEID_GLOBAL_STATE } from "../../../globalStore/globalStore";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { LIST_BY_GLOBAL_STATES } from "globalStore/globalStore";

import { COMMON_COMPONENTS_STATES } from "../../../globalStore/globalStore";
import { TagCarsComponent } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";
import { ActionWrapper } from "../../../pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import { TagCarsComponent1 } from "../../../commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/TagCars";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export const Cars = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const [height, setHeight] = useState(0);
  const [filterHeight, setFilterHeight] = useState(0);
  const [searchHeaderHeight, setSearchHeaderHeight] = useState(0);

  const filterDataRef = useRef(null);
  const filterH = useRef(null);
  const searchH = useRef(null);

  const [carListCount, setCarListCount] = useState(0);
  const [carListCountInvert, setCarListCountInvert] = useState(0);
  const [getFleetcarsInput, setGetFleetcarsInput] = useState("");
  const [getFleetcarsInputInvert, setGetFleetcarsInputInvert] = useState("");
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [disableselectAll, setDisableSelectAll] = useState(false);
  const [disableselectAllInvert, setDisableSelectAllInvert] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAllInvert, setSelectAllInvert] = useState(false);
  const dispatch = useDispatch();
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);

  const { showTagCarsState, showTagCarsStatenew, showTagCarState2 } =
    useHookstate(COMMON_COMPONENTS_STATES);

  const { listBy } = useHookstate(LIST_BY_GLOBAL_STATES);

  const { getCarsData, siteSettingDataReduxStateStatus } =
    useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (filterDataRef.current?.clientHeight === null) {
      return;
    } else {
      setHeight(filterDataRef.current?.clientHeight);
    }
  });

  //-------filter height ---------------
  useEffect(() => {
    if (filterH.current?.clientHeight === null) {
      return;
    } else {
      setFilterHeight(filterH.current?.clientHeight);
    }
  });

  //-------Search Header height ---------------
  useEffect(() => {
    if (searchH.current?.clientHeight === null) {
      return;
    } else {
      setSearchHeaderHeight(searchH.current?.clientHeight);
    }
  });

  useEffect(() => {
    dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
  }, [siteId.get()]);

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST || getCarsData === API_STATUSES.REQUEST) {
    return <Loader />;
  }

  const TopSection = `${
    windowDimensions.width <= 850
      ? filterHeight + searchHeaderHeight + 58 + 70
      : filterHeight + searchHeaderHeight + 58
  }`;

  const totalHeight = `${
    windowDimensions.width <= 850
      ? height + filterHeight + searchHeaderHeight + filterHeight + 58 + 130
      : height + filterHeight + searchHeaderHeight + filterHeight + 58
  }`;

  return (
    <>
      <Container style={{ backgroundColor: isLoading.get() ? "#f7f7f7" : "" }}>
        <div ref={filterH}>
          <SortByHeader />
        </div>
        <div ref={searchH}>
          <SearchHeader
            invert={false}
            count={carListCount}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            disableselectAll={disableselectAll}
            disableselectAllInvert={disableselectAllInvert}
            getFleetcarsInput={getFleetcarsInput}
            setGetFleetcarsInput={setGetFleetcarsInput}
          />
        </div>
        {showTagCarsState.get() ? <TagCarsComponent /> : <></>}
        {showTagCarState2.get() ? <TagCarsComponent /> : <></>}
        {showTagCarsStatenew.get() ? <TagCarsComponent1 /> : <></>}

        <div ref={filterDataRef}>
          <ListView
            invert={false}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            selectAllInvert={selectAllInvert}
            setSelectAllInvert={setSelectAllInvert}
            setDisableSelectAll={setDisableSelectAll}
            setDisableSelectAllInvert={setDisableSelectAllInvert}
            setCarListCount={setCarListCount}
            maxHeight={
              listBy.get() !== "NONE"
                ? "230px"
                : `calc(100vh - ${TopSection}px)`
            }
            getFleetcarsInput={getFleetcarsInput}
          />
        </div>
        {listBy.get() !== "NONE" && (
          <>
            <SearchHeader
              invert={true}
              count={carListCountInvert}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              disableselectAll={disableselectAll}
              disableselectAllInvert={disableselectAllInvert}
              className="new-search-header"
              getFleetcarsInput={getFleetcarsInputInvert}
              setGetFleetcarsInput={setGetFleetcarsInputInvert}
            />
            {showTagCarsState.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            {showTagCarState2.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}
            {showTagCarsStatenew.get() ? (
              <FleetFindCar>
                <ActionWrapper>
                  <TagCarsComponent1 />
                </ActionWrapper>
              </FleetFindCar>
            ) : (
              <></>
            )}

            <ListView
              invert={true}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              selectAllInvert={selectAllInvert}
              setSelectAllInvert={setSelectAllInvert}
              setDisableSelectAll={setDisableSelectAll}
              setDisableSelectAllInvert={setDisableSelectAllInvert}
              setCarListCountInvert={setCarListCountInvert}
              maxHeight={`calc(100vh - ${totalHeight}px)`}
              getFleetcarsInput={getFleetcarsInputInvert}
            />
          </>
        )}
      </Container>
    </>
  );
};
